import config from '../config';
import { PzptApiOptions } from './PzptApiOptions';
import { PzptApi } from './createPzptRequest';
import { BaseResponse, ImageData } from './shared';

interface QueryImageListByCodeRequest {
  codes: string; //逗号隔开
}

interface QueryImageListByCodeResponse extends BaseResponse {
  data: Array<ImageData>;
}

/**
 * 根据多个素材编码查询素材
 * @param params
 * @returns
 */

export async function queryImageListByCode(request: QueryImageListByCodeRequest, options?: PzptApiOptions) {
  const url = config.pzptLink + '/api/contest/getItems';
  return PzptApi.fetch<QueryImageListByCodeResponse>(url, request, options);
}
